import React, { useState } from 'react';

/**
 * テキストをクリップボードにコピーするボタン
 *
 * @param {string} text - コピー対象のテキスト
 * @param {string} [className] - 追加CSSクラス
 */
function CopyButton({ text, className = '' }) {
    const [copied, setCopied] = useState(false);

    const handleCopy = async (e) => {
        e.stopPropagation(); // 親のダブルクリック編集などを発火させない
        if (!text) return;

        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch {
            // clipboard API非対応ブラウザのフォールバック
            const el = document.createElement('textarea');
            el.value = text;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }
    };

    return (
        <button
            type="button"
            className={`copy-button ${copied ? 'copy-button--copied' : ''} ${className}`}
            onClick={handleCopy}
            aria-label="コピー"
            title={copied ? 'コピーしました！' : 'クリップボードにコピー'}
            disabled={!text}
        >
            {copied ? (
                <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                    <span>コピー完了</span>
                </>
            ) : (
                <>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                    </svg>
                    <span>コピー</span>
                </>
            )}
        </button>
    );
}

export default CopyButton;
